<!--
 * @Author: 仙道
 * @Date: 2022-07-03 20:05:33
 * @LastEditTime: 2022-07-03 21:02:46
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/eMaintenance/modules/EditCell.vue
-->
<template>
  <!-- <div class="editable-cell">
    <div class="editable-cell-input-wrapper">
      <a-input :value="value" @change="handleChange" @pressEnter="check" />
    </div>
  </div>-->
  <div class="editable-cell">
    <div class="editable-cell-input-wrapper" v-if="editable">
      <a-input :value="value" @change="handleChange" @pressEnter="check" />
      <a-icon @click="check" class="editable-cell-icon-check" type="check" />
    </div>
    <div class="editable-cell-text-wrapper" v-else>
      {{ value || ' ' }}
      <a-icon @click="edit" class="editable-cell-icon" type="edit" />
    </div>
  </div>
</template>

<script>

  export default {
    name: 'EditCell',
    components: {

    },
    props: {
      text: Number,
    },
    data () {
      return {
        value: this.text,
        editable: false,
      };
    },
    methods: {
      handleChange (e) {

        const value = e.target.value;
        this.value = value;
      },
      check () {
        this.editable = false;
        this.$emit('change', this.value);
      },
      edit () {
        this.editable = true;
      },
    }
  }
</script>

 